import { render, staticRenderFns } from "./AddCreditDialog.vue?vue&type=template&id=be870baa&scoped=true"
import script from "./AddCreditDialog.vue?vue&type=script&lang=js"
export * from "./AddCreditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be870baa",
  null
  
)

export default component.exports